module.exports = __webpack_public_path__ + "img/close (4).6635d871.svg";